import React from 'react';
import { Badge as MuiBadge, BadgeProps } from '@mui/material';

/**
 * Renders a Badge component
 */
export const Badge: React.FC<React.PropsWithChildren<BadgeProps>> = (props: BadgeProps) => <MuiBadge {...props} />;
